module.exports = __webpack_public_path__ + "static/media/15.3b1572a9.jpg";